export const MENU_ICONS_BY_ID = {
  '1': 'fas fa-home',
  '2': 'fas fa-calculator',
  '3': 'fas fa-folder-open',
  '4': 'fas fa-calendar-alt',
  '5': 'fas fa-tasks',
  '6': 'fas fa-file-signature',
  '7': 'fas fa-envelope',
  '8': 'fas fa-bullhorn',
  '9': 'fas fa-cogs',
}

export const SCREEN_ICONS_BY_ID = {
  '1': 'fas fa-home',
  '2': 'fas fa-calculator',
  '3': 'fas fa-folder-open',
  '4': 'fas fa-comment-dots',
  '5': 'fas fa-truck',
  '6': 'bx bxs-report',
  '7': 'fas fa-check-square',
  '8': 'fas fa-search-plus',
  '9': 'fas fa-file-alt',
  '10': 'bx bxs-envelope',
  '11': 'fas fa-newspaper',
  '12': 'fas fa-cog',
  '13': 'fas fa-calendar-day',
}
